import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { FaEdit } from "react-icons/fa";
import { MdRemoveCircle } from "react-icons/md";
import { AssuranceInterface, ShowAssurancesContext } from "./types";
import { useTranslation } from "react-i18next";
import { hostName } from "../../requestMethods";
import { useNavigate } from "react-router";

const DataAssurances: React.FC = () => {
  const { assurances } = useSelector((state: State) => state.assurances);

  const {  
    showEditModal, 
    setShowEditModal,
    showDeleteModal, 
    setShowDeleteModal,
    setSelectedAssurance,
  } = useContext(ShowAssurancesContext)

  const toggleEditAssurance = (assurance: AssuranceInterface) => { 
    setShowEditModal(!showEditModal)
    setSelectedAssurance(assurance)
  };

  const toggleDeleteAssurance = (assurance: AssuranceInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedAssurance(assurance)
  };

  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col border mt-3">
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden">
          <table className="min-w-full text-center text-sm font-light border border-black">
            <thead className="border-b font-medium bg-main text-white border-black">
              <tr>
                <th className="px-4 py-4 border-r border-black">{t("Nom")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Photo")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Description")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {assurances.map((assurance: AssuranceInterface, index) =>(
                <tr className="border-b bg-white border-black" key={index}>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium hover:bg-gray-200" onClick={() => navigate(`${assurance._id}`)}>
                    {assurance.name}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      {assurance.image && 
                        <img className="rounded-full w-28 h-28" src={hostName + "imgs/assurances/" + assurance.image} alt="ss"/>
                      }
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {assurance.description}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      <FaEdit
                        className="text-second text-2xl"
                        onClick={() => toggleEditAssurance(assurance)}
                      />
                      <MdRemoveCircle
                        className="text-red text-2xl"
                        onClick={() => toggleDeleteAssurance(assurance)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
    // <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-2 mt-4">
    //   {assurances.map((assurance: AssuranceInterface, index) => (
    //     <div className={`${assurance._id === AssId  ? "bg-main" : "" } bg-white px-6 py-4 rounded border shadow hover:bg-main`} 
    //     // style={{ backgroundColor: assurance.color }}           
    //       key={index}>
    //       <div onClick={() => {
    //         setSelectedAssurance(assurance)
    //         navigate(`/assurance/${assurance._id}`)
    //       }}>
    //         <div>
    //           <img className="w-40 h-40" src={hostName + "imgs/assurances/" + assurance.image} alt="ss"/>
    //         </div>
    //         <span className="flex justify-between">
    //           {t("Societé")} : <b>{assurance.name}</b>
    //         </span>
    //         <span className="flex justify-between">
    //           {t("description")} : <b>{assurance.description}</b>
    //         </span>
    //       </div>
          // <div className="flex justify-center">
          //   <FaEdit
          //     className="text-blue"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleEditAssurance(assurance)}
          //   />
          //   <MdRemoveCircle
          //     className="text-red"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleDeleteAssurance(assurance)}
          //   />
          // </div>
    //     </div>

    //   ))}
    // </div>
};

export default DataAssurances;
